// App settings (roadmap #68), per device: what a newly added item starts as,
// and how dates read. Every read is safe without storage (tests, private mode).

const KEY = "settings:app";

export const ADD_STATUS_OPTIONS = [
	{ value: "want_to_check", label: "Want to (on the radar)" },
	{ value: "haven_started", label: "To do (in the backlog)" },
];
export const ADD_OWNERSHIP_OPTIONS = [
	{ value: "not_owned", label: "Not owned" },
	{ value: "want_it", label: "Want it" },
	{ value: "have_it", label: "Have it" },
];
export const DATE_FORMATS = [
	{ value: "auto", label: "Like my device", example: null },
	{ value: "dmy", label: "21 Oct 2026", locale: "en-GB" },
	{ value: "mdy", label: "Oct 21, 2026", locale: "en-US" },
	{ value: "iso", label: "2026-10-21", locale: null },
];

const DEFAULTS = { add_status: "want_to_check", add_ownership: "not_owned", date_format: "auto" };

export function loadSettings() {
	try {
		return { ...DEFAULTS, ...(JSON.parse(globalThis.localStorage?.getItem(KEY) ?? "null") ?? {}) };
	} catch {
		return { ...DEFAULTS };
	}
}

export function saveSettings(patch) {
	const next = { ...loadSettings(), ...patch };
	try {
		globalThis.localStorage?.setItem(KEY, JSON.stringify(next));
	} catch {
		// not saved
	}
	return next;
}

export function defaultAddStatus() {
	const v = loadSettings().add_status;
	return ADD_STATUS_OPTIONS.some((o) => o.value === v) ? v : DEFAULTS.add_status;
}

export function defaultAddOwnership() {
	const v = loadSettings().add_ownership;
	return ADD_OWNERSHIP_OPTIONS.some((o) => o.value === v) ? v : DEFAULTS.add_ownership;
}

// → { iso: boolean, locale: string | undefined } for the date formatters.
export function dateStyle() {
	const f = DATE_FORMATS.find((d) => d.value === loadSettings().date_format) ?? DATE_FORMATS[0];
	return { iso: f.value === "iso", locale: f.locale ?? undefined };
}
